import { systemCode } from '@root/package.json';

/** 角色归属 */
export enum ROLE_TYPE_ENUM {
  /** 外部 */
  OUTER = 1000,
  /** 内部 */
  INNER = 2000,
}

export const ROLE_TYPE_LIST = [
  { value: ROLE_TYPE_ENUM.OUTER, label: '外部' },
  { value: ROLE_TYPE_ENUM.INNER, label: '内部' },
];

/** fashion系统编码 */
export const CURRENT_CLIENT_CODE = systemCode;
/** SSO系统编码 */
export const SSO_SYSTEM_CODE = 'TG_FASHION_DESIGN_ADMIN';
// eslint-disable-next-line vue/max-len
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+TEVavNwrEtklo1PcCInmaIF+0AOSlc9gUE7VMbM1ONAspScO5so7Q7OGy39DIiJm0uaNnm19XiJrj1C4omitlSdLDgey6Ar2ij60uSBduyzAUEs5Zu66U4lio6O859MSf8/zz64eSn2PIwhYxbWVD33X+PPbuyqLIIW3dslcRwIDAQAB';

/*
 * SSO url 返回授权code 字段名称
 * */
export const SSO_AUTHORIZATION_CODE = 'code';

/**
 * 外部系统跳转携带 token 和 tenantId
 */
export const SSO_TOKEN = 'ssoToken';
export const TENANT_ID = 'tenantId';

/**
 * yes / no
 */
export enum YES_NO_ENUM {
  YES = 'YES',
  NO = 'NO',
}

export const ENABLE_DISABLE_LIST = [
  { value: YES_NO_ENUM.YES, label: '启用' },
  { value: YES_NO_ENUM.NO, label: '停用' },
];

/** 数字 是否 */
export enum YES_OR_NO_NUMBER_ENUM {
  YES = '1',
  NO = '0',
}

/** 数字 是否 */
export enum YES_OR_NO_INT_ENUM {
  YES = 1,
  NO = 0,
}
export const YES_OR_NO_INT_NUMBER_LIST = [
  { value: YES_OR_NO_INT_ENUM.YES, label: '是' },
  { value: YES_OR_NO_INT_ENUM.NO, label: '否' },
];

export const ENABLE_DISABLE_NO_LIST = [
  { value: YES_OR_NO_NUMBER_ENUM.YES, label: '启用' },
  { value: YES_OR_NO_NUMBER_ENUM.NO, label: '禁用' },
];
export const ENABLE_DISABLE_NO_REVERT_LIST = [
  { value: YES_OR_NO_NUMBER_ENUM.YES, label: '禁用' },
  { value: YES_OR_NO_NUMBER_ENUM.NO, label: '启用' },
];
export const YES_OR_NO_NUMBER_LIST = [
  { value: YES_OR_NO_NUMBER_ENUM.YES, label: '是' },
  { value: YES_OR_NO_NUMBER_ENUM.NO, label: '否' },
];

export const ENABLE_STOP_NO_LIST = [
  { value: YES_OR_NO_NUMBER_ENUM.YES, label: '启用', color: 'success' },
  { value: YES_OR_NO_NUMBER_ENUM.NO, label: '停用', color: 'danger' },
];

export const ENABLE_STOP_NO_INT_LIST = [
  { value: YES_OR_NO_INT_ENUM.YES, label: '启用', color: 'success' },
  { value: YES_OR_NO_INT_ENUM.NO, label: '停用', color: 'danger' },
];

export enum REGION_ENUM {
  GUANGZHOU = '4',
  HANGZHOU = '8',
}
export const REGION_LIST = [
  { value: REGION_ENUM.GUANGZHOU, label: '广州' },
  { value: REGION_ENUM.HANGZHOU, label: '杭州' },
];

/**
 * 轮询任务的taskStatus
 *  任务状态：0-排队中；10-生成中；20-已中止；30-已完成；40-无效；50-失败；60-超时失败；
 */
export const enum LOOP_TASK_STATUS_INT_ENUM {
  /** 0-排队中 */
  QUEUEING = 0,
  /** 10-生成中 */
  GENERATING = 10,
  /** 20-已中止 */
  ABORTED = 20,
  /** 30-已完成 */
  COMPLETED = 30,
  /** 40-无效 */
  INVALID = 40,
  /** 50-失败 */
  FAILED = 50,
  /** 60-超时失败 */
  TIEM_OUT_FAILED = 60,
}
